<template>
  <footer class="footer footer-theme position-relative" id="footer">
    <div class="container-fluid fs-6 text-white lh-sm py-3">
      <div class="row g-0 g-md-5 mb-4 mt-0">
        <div class="col-auto">
          <p><span class="fw-bold">Jobnet.AG</span><br>
            Kolonnenstraße 8<br>
            10827 Berlin<br>
            <a href="mailto:info@jobnet.solutions">info@jobnet.solutions</a></p>
          <p>
            <i class="bi bi-headset me-1"></i>HOTLINE<br>
            <b-icon icon="headset" class="me-1" /><a href="mailto:hotline@jobnet.solutions">hotline@jobnet.solutions</a><br>
            <span :class="`fi fis fi-de2 me-1`"></span><a href="tel:+4930577001255">+49.30.5770012-55</a><br>
            <span :class="`fi fis fi-at me-1`"></span><a href="tel:+4317481010">+43.1.7481010</a></p>
        </div>
        <div class="col">
          <p><span class="fw-bold hyphens-0">Digital Employment Solutions</span><br>
            Die Jobnet.AG ist ein IT-Lösungsanbieter für institutionelle Arbeitsmarktakteure: öffentliche Arbeitsmarktdienstleister, Jobcenter, Bildungsträger, Transfergesellschaften, Jobdrehscheiben, Einrichtungen der beruflichen Reha, Wirtschaftsförderungen, Welcome Center und Fachkräfteprogramme. Wir kombinieren IT- und Arbeitsmarkt-Know-how zu hochwertigen Lösungen für mehr und gute Beschäftigung.</p>
        </div>
        <div class="col-auto">
          <p><span class="fw-bold">Soziale Netzwerke:</span><br>
            Folgen Sie uns in den sozialen Netzwerken:</p>
          <p class="d-flex align-items-center">
<!--            <a href="https://www.facebook.com/pages/JobnetAG/606996422725235"-->
<!--               title="Die Jobnet.AG bei Facebook" target="_blank"-->
<!--               aria-label="Facebook"-->
<!--               class="btn btn-primary btn-sm border-0 me-1">-->
<!--              <b-icon icon="facebook" />-->
<!--            </a>-->
<!--            <a href="https://www.xing.com/companies/jobnet.ag%25257cmenschen.miteinander.verbinden."-->
<!--               title="Die Jobnet.AG bei XING" target="_blank"-->
<!--               aria-label="x"-->
<!--               class="btn btn-primary btn-sm border-0 me-1">-->
<!--              <b-icon icon="x-circle" />-->
<!--            </a>-->
            <a href="https://www.linkedin.com/company/jobnet-ag-digital-employment-solutions/"
              aria-label="linkedin"
              title="Die Jobnet.AG bei LinkedIN" target="_blank" class="btn btn-primary btn-sm border-0 me-1">
              <b-icon icon="linkedin" />
            </a>
<!--            <a href="https://twitter.com/jobnetAG"-->
<!--               aria-label="twitter"-->
<!--               title="Die Jobnet.AG bei Twitter" target="_blank"-->
<!--               class="btn btn-primary btn-sm border-0">-->
<!--              <b-icon icon="twitter" />-->
<!--            </a>-->
          </p>
        </div>
      </div>

      <div class="row my-4 pt-4 d-none d-lg-block">
        <div class="col-12">
          <div class="row">
            <div class="col-auto"  v-for="(item, index) in navigation" :key="index">
              <a class="fw-bolder text-white hyphens-0" :href="item.url" :title="item.title" target="_blank">{{item.title}}</a>
              <div v-if="item.child">
                <p class="fs-7 hyphens-0 lh-1 mb-1" v-for="(sub1, sub1index) in item.child" :key="sub1index">
                  <a :href="sub1.url" :title="sub1.title" target="_blank">{{ sub1.title }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p class="fs-7">© {{ new Date().getFullYear() }} Jobnet.AG / <a href="https://www.jobnet.ag/JobnetAG/Kontakt/impressum.php" target="_blank" title="Link zum Impressum">Impressum</a> / <a href="https://www.jobnet.ag/JobnetAG/datenschutz.php" title="Link zu den Datenschutzbestimmungen" target="_blank">Datenschutz</a> / <a href="#" @click.prevent="showCookieSettings">Cookie-Einstellungen</a></p>
        </div>
        <div class="col-auto ms-auto">
          <p class="fs-7"><a href="https://www.jobnet.ag/1676" target="_blank">www.jobnet.ag/1676</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';
import { navigation } from '@/config/navigation';

interface LinkItem {
  text: string
  link?: string
  hasIcon?: boolean
}

@Component
export default class FooterComponent extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de'; // AppModule.language;
  }

  get navigation() {
    return navigation;
  }

  showCookieSettings() {
    this.$root.$emit('show-cookie-banner');
  }
}
</script>
<style lang="scss" scoped>
#footer {
  background-color: var(--global-footer-background-color);
  .fs-7 {
    font-size: 0.85rem !important;
  }
  p, a {
    font-weight:  300;
  }
}
</style>
